type Props = {
    imageUrl: string;
    title: string;
    description?: string;
    producer?: string;
    isLive?: boolean;
    className?: string;
};

export default function ProgramSlideCard({
                                             imageUrl,
                                             title,
                                             description = "",
                                             producer = "",
                                             isLive = false,
                                             className = "",
                                         }: Props) {
    return (
        <div
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${className}`}
            aria-label={`${title}${producer ? ` by ${producer}` : ""}`}
        >
            <img
                src={imageUrl}
                alt={title}
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-black/20 to-black/60"/>

            {/* text block (bottom-left) */}
            <div className="absolute text-end right-4 bottom-4 text-white">

                <div className="text-white/80 text-sm sm:text-base truncate">
                    {title}
                </div>

                {producer && (
                    <div className="mt-0.5 text-2xl sm:text-3xl font-bold leading-tight line-clamp-2">
                        {producer}
                    </div>
                )}

                {description && (
                    <div className="mt-1 text-white/80 text-sm sm:text-base line-clamp-2">
                        {description}
                    </div>
                )}
            </div>

            {/* live chip (top-left) */}
            {isLive && (
                <div className="absolute right-2 top-2">
                    <div
                        className="backdrop-blur rounded-xl border border-white/25 px-2.5 py-1.5 bg-red-600/80 text-white text-xs inline-flex items-center gap-1.5">
                        <span className="inline-block w-2 h-2 rounded-full bg-white"/>
                        Op’ie Lug
                    </div>
                </div>
            )}
        </div>
    );
}
